import {
  EMAIL_TEMPLATES_SET_TEMPLATES,
  EMAIL_TEMPLATES_UPDATE_TEMPLATE,
  EMAIL_TEMPLATES_REPLACE_TEMPLATE
} from './actionType';

// Update new template
export const updateTemplate = payload => ({
  type: EMAIL_TEMPLATES_UPDATE_TEMPLATE,
  payload
});

export const replaceTemplate = payload => ({
  type: EMAIL_TEMPLATES_REPLACE_TEMPLATE,
  payload
});

// Set Templates
export const setTemplatesData = templates => ({
  type: EMAIL_TEMPLATES_SET_TEMPLATES,
  templates
});



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/flow/emailTemplateFlow/action.js